import React, { useEffect, useState } from "react";
import useStyles from "../../../assets/styles/styles";
import {
    Box,
    Typography,
    IconButton,
    CircularProgress,
    ClickAwayListener,
    Divider,
    FormControl,
    InputLabel,
    Card as MuiCard, CardContent
} from "@material-ui/core";
import "../../AskTurn/SelectDateDrawer/doctorCalendarAgenda.css";
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import { useDispatch } from "react-redux";
import { getVitalSignsDetailAction } from "../../../redux/actions/appointmentsActions";
import FavoriteIcon from "@material-ui/icons/Favorite";
import CustomButton from "../../../controls/Button/CustomButton";
import TuneIcon from '@material-ui/icons/Tune';
import { LocalizationProvider, MobileDatePicker } from "@material-ui/lab";
import { es } from "date-fns/locale";
import TextField from '@mui/material/TextField';
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { textChange } from "../../../utils/utilsFunctions";

const TabSignosVitales = ({
    modelVitalSigns,
    handleClickSeeMore,
    loading,
    NotFound,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [openPicker, setOpenPicker] = useState(false);
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [isInitialLoad, setIsInitialLoad] = useState(true);



    const filteredVitalSigns = React.useMemo(() => {
        if (!modelVitalSigns || modelVitalSigns.length === 0) {
            return [];
        }

        if (isInitialLoad) {
            return modelVitalSigns;
        }

        return modelVitalSigns.filter((item) => {
            const itemDate = new Date(item.fechaFormateada);

            const startDate = dateStart ? new Date(dateStart).setHours(0, 0, 0, 0) : null;
            const endDate = dateEnd ? new Date(dateEnd).setHours(23, 59, 59, 999) : null;

            return (
                (!startDate || itemDate >= startDate) &&
                (!endDate || itemDate <= endDate)
            );
        });
    }, [modelVitalSigns, dateStart, dateEnd, isInitialLoad]);


    useEffect(() => {
        dispatch(getVitalSignsDetailAction());
    }, []);


    const handleDateChange = (isStart, newValue) => {
        setIsInitialLoad(false);

        if (isStart) {
            setDateStart(newValue);
        } else {
            setDateEnd(newValue);
        }
    };



    const dateDropDown = () => {
        return (
            <Box style={{ alignSelf: "center" }} className={`${classes.headerFiltro} ${classes.marginTop}`}>

                <FormControl className={classes.medicalHistoryDateSelectorFrom}>
                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink  >{"DESDE"}</InputLabel>
                    <Box className={classes.top22} style={{ display: "flex", justifyContent: "space-between" }}>
                        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}  >
                            <MobileDatePicker
                                cancelText="Cancelar"
                                toolbarTitle=""
                                value={dateStart}
                                onChange={(newValue) => handleDateChange(true, newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                format="dd/MM/YYYY"
                            />
                        </LocalizationProvider>
                        <CalendarTodayIcon />
                    </Box>
                </FormControl>

                <FormControl className={classes.medicalHistoryDateSelectorUntil} >
                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink  >{"HASTA"}</InputLabel>
                    <Box className={classes.top22} style={{ display: "flex", justifyContent: "space-between", }}>
                        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}  >
                            <MobileDatePicker
                                cancelText="Cancelar"
                                toolbarTitle=""
                                value={dateEnd}
                                onChange={(newValue) => handleDateChange(false, newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                format="dd/MM/YYYY"
                            />
                        </LocalizationProvider>
                        <CalendarTodayIcon />
                    </Box>
                </FormControl>

            </Box>
        );
    }


    const dateFilterButton = () => {
        return (
            <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={handleClickAway}>
                <Box style={{ position: "relative" }}>
                    <CustomButton
                        onClick={handleClick}
                        customClass={`${classes.btnFilterAppointment} ${classes.dateFilterButton}`}
                        icon={<TuneIcon className={classes.iconFilter} />}
                    />
                    {
                        openPicker &&
                        (
                            <Box container alignItems="center" className={`${classes.dropDownMedicalHistory} ${classes.dropdownLaboratory}`} style={{ zIndex: 1 }}>
                                <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>{"PERIODO"}</Typography>
                                <Divider classes={{ root: classes.dividerFilter }} />
                                {dateDropDown()}
                            </Box>
                        )
                    }
                </Box>
            </ClickAwayListener>
        );
    }



    const handleClickAway = () => {
        setOpenPicker(false);
    };


    const handleClick = () => {
        setOpenPicker((prev) => !prev);
    };


    return (
        <>
            <Box className={`${classes.appointmentsAutocompleteContainer} ${classes.laboratoryBox}`} >
                {dateFilterButton()}
            </Box>

            <Box className={`${classes.listCardMedicalHistoryVitalSigns}`} style={{ gap: "20px" }} >
                {loading ? (
                    <Box className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.whiteCircularProgress}`}>
                        <CircularProgress />
                    </Box>
                ) : filteredVitalSigns?.length > 0 ? (
                    <>
                        {filteredVitalSigns?.map((item, i) => (
                            <MuiCard key={item?.id || i}
                                index={i} className={` ${classes.detailCardMuiLaboratory}`} >
                                <CardContent className={classes.cardContentMuiCardDetailPatient}>
                                    <Box className={classes.divCardContentBottonCallMedical} >
                                        <Box className={classes.medicalCenterIconDetailPatient}>
                                            <FavoriteIcon className={classes.vitalSignsIconDetail} />
                                        </Box>
                                        <Box className={classes.cartillaPhonesSection}>
                                            <Typography className={classes.detailPatientName}>
                                                {item?.titulo}
                                            </Typography>
                                        </Box>
                                        <Box className={classes.divCardContentView}>
                                            <Box className={classes.buttonZoneSection}>
                                                <Box className={`${classes.sectionButtons} ${classes.btnAuthorizationCard} buttonZoneContainer`}>
                                                    <Box className={classes.buttonZoneCardVitalSigns}>
                                                        <IconButton onClick={handleClickSeeMore(item)} customClass={classes.customHeaderBtn}>
                                                            <Typography className={`${classes.viewPatientDetails} ${classes.txtEllipsis}`} >
                                                                VER
                                                            </Typography>
                                                            <ControlPointOutlinedIcon className={classes.iconFilterPatientDetails} />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={classes.medicalCenterIconDetailPatient}>
                                            <Typography className={classes.detailLaboratoryDate}>
                                                {new Date(item.fechaFormateada).toLocaleDateString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                })}
                                            </Typography>
                                        </Box>
                                        <Box className={`${classes.resultLaboratoryContainer} ${classes.cartillaPhonesSection}`}>
                                            <Typography className={`${classes.detailLaboratory} ${classes.txtDescription} ${classes.descriptionCardSuppliers} ${classes.medicalCardAddressStyles}`}>
                                                {item.resultados && item.resultados.length > 0
                                                    ? item.resultados
                                                        .map(r => `${textChange(r.nombre.toLowerCase())}: ${r.valor} ${r.unidad}`.trim())
                                                        .join(' | ')
                                                    : 'Sin resultados'}
                                            </Typography>
                                        </Box>

                                    </Box>
                                </CardContent>
                            </MuiCard>
                        ))}

                    </>
                ) : (
                    <NotFound
                        customMsg={
                            <Box className={classes.contentNotFound}>
                                <Typography>No tenés historial</Typography>
                            </Box>
                        }
                    />
                )}
            </Box>

        </>
    );
};

export default TabSignosVitales;